import React from 'react';
import '../tooltips/tooltips.css'
import stats from '../custom_icons/stats.svg'
import copy from '../custom_icons/copy.svg'
import trash_red from '../custom_icons/trash_red.svg'
import users from '../custom_icons/users.svg'
import { getLocalizedStrings } from '../utils_android/LocalizedStrings';
import { openDuplicateOrderThisWindow } from '../utils_android/Utils';
var strings = getLocalizedStrings()
class OrderMoreTooltip extends React.Component {
    constructor(props){
        super(props)
        
    }
    openStats = () => {
        window.location.href = "/statistics?bundle=" + this.props.order.bundle
    }
    duplicateOrder = () => {
        openDuplicateOrderThisWindow(this.props.order)
    }
    showIdfa = () => {
        this.props.showIdfa()
        this.props.toogleMore()
    }
    deleteOrder = () => {
        this.props.toogleMore()
        this.props.deleteOrder()
    }
    render(){
      
            return (
                <div className="display_block">
                    <div onClick={this.props.toogleMore} className="tooltip_bg_up_balance"/>
                    <div className="tooltip_more_plashka">
                        <div className="tooltip_more_arrow"/>
                        <div className="bg_white_line"/>
                        <div className="display_block">
                            <div className="padding_24 tooltip_right">
                                <div onClick={this.openStats} className="up_balance_info hover">
                                    <img src={stats}></img>
                                    <p className="up_balance_info_text">{strings.statsProp}</p>
                                </div>

                                <div onClick={this.duplicateOrder} className="up_balance_info top_16 hover">
                                    <img src={copy}></img>
                                    <p className="up_balance_info_text">{strings.duplicateOrder}</p>
                                </div>

                                <div onClick={this.showIdfa} className="up_balance_info top_16 hover">
                                    <img src={users}></img>
                                    <p className="up_balance_info_text">{strings.idfaTitle}</p>
                                </div>

                                <div onClick={this.deleteOrder} className="up_balance_info top_16 hover">
                                    <img src={trash_red}></img>
                                    <p className="up_balance_info_text red_text">{strings.deleteOrderInfo}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ); 
          
    }
}
export default OrderMoreTooltip;
